import productRelatedProducts from "./components/product-related-products.js";
import countdown from "./components/countdown.js";
import productOptions from "./components/product-options.js";
import "./components/product-main-gallery.js";
import "./components/native-reviews.js";

// countdown
countdown();
productOptions();

// swipers
productRelatedProducts();
